import { Search } from '@/DTOS/InterventionFile/Search';
import request from '../../utils/request';
import { getBaseUrl } from '../../utils/baseUrl';

const InterventionFileService = {
  search: (search: Search) => {
    return request('/interventionFile/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },
  searchCounts: (search: Search) => {
    return request('/interventionFile/searchCounts', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    formData: {
      type: any;
      //number: any;
      companyId: any;
      workPlaceId: any;
      agentId: any;
      requestFileId?: any;
      mentenancePlanningId?: any;
      statusId: any;
      offerId: any;
      hasJournal: any;
      attachedImage: any;
      reportedDefect: any;
      ascertainment: any;
      takenIntoService: any;
      deviceRepaired: any;
      estimatedPrice: any;
      operations: any;
      isAccumulatorChanged: any;
      isBatteryChanged: any;
      consumptionDetails: any;
      canBeUpgradedWithPresales: any;
      canBeUpgradedWithoutPresales: any;
      recommendationDetails: any;
      helionEngineers: any;
      representativeSignature: any;
      deliveryDate: any;
      timeTransport: any;
      traveledKilometers: any;
      laborTime: any;
      signature: any;
      contactPersonObservations: any;
      latitude: any;
      longitude: any;
      isActive: any;
      changes: any;
      device: any;
      otherActivities: any;
      isInvoiceSent: any;
      isNotInvoiced: any;
      isGuarantee: any;
      isFree: any;
      interventionFileEquipments: any;
      interventionFileSystemTypes: any;
      interventionFileInvoiceFiles: any[];
      interventionFilePerformOperations: any;
    }
  ) => {
    // Set isDraft based on representative signature
    const isDraft = !formData.representativeSignature;

    return request('/interventionFile/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          ...formData,
          id: id,
          isDraft: isDraft,
        },
      }),
    });
  },

  print: (id: string) => {
    return request(
      `/interventionFile/files/${id}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
      },
      true
    );
  },
  getPrintUrl: (id: string) => `${getBaseUrl()}/interventionFile/files/${id}`,
  getPrintPreviewUrl: (id: string) => `${getBaseUrl()}/interventionFile/files/${id}/preview`,

  upload: (/** @type {any} */ file: any) => {
    return request(
      '/interventionFile/upload',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
        body: file,
      },
      true
    );
  },

  downloadFile: (/** @type {any} */ formData: any) => {
    return request(
      '/interventionFile/downloadFile',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
        body: formData,
      },
      true
    );
  },

  downloadAllJournals: (workPlaceId: string, deliveryDate: any) => {
    return request(
      `/interventionFile/journals/${workPlaceId}/${deliveryDate}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      },
      true
    );
  },

  generateDailyReport: (reportDate: Date) => {
    // Format date as YYYY-MM-DD without timezone conversion
    const formattedDate =
      reportDate.getFullYear() +
      '-' +
      String(reportDate.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(reportDate.getDate()).padStart(2, '0');

    return request(`/interventionFile/generateDailyReport?reportDate=${formattedDate}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },

  generateMonthlyReport: (reportDate: Date) => {
    // Format date as YYYY-MM-DD without timezone conversion
    const formattedDate =
      reportDate.getFullYear() +
      '-' +
      String(reportDate.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(reportDate.getDate()).padStart(2, '0');

    return request(`/interventionFile/generateMonthlyReport?reportDate=${formattedDate}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },

  // Add method to check draft status
  checkDraftStatus: (id: string) => {
    return request(`/interventionFile/isDraft/${id}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },
};

export default InterventionFileService;
